var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1125_953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3003 16.6666H1.66699L11.9503 24.0166L8.05033 36.6666L18.3337 28.8499L28.6337 36.6666L24.717 24.0166L35.0003 16.6666H22.367L18.3337 3.33325L14.3003 16.6666ZM35.6003 36.6666L32.5003 26.6499L39.467 21.6666H33.7337L28.6003 25.3333L31.0337 33.1999L35.6003 36.6666ZM28.3337 13.3333L25.3003 3.33325L23.567 9.08325L24.8503 13.3333H28.3337Z",
    fill: "url(#paint0_linear_1125_953)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1125_953",
    x1: 20.567,
    y1: 3.33325,
    x2: 20.567,
    y2: 36.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1125_953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingIcon);
export default __webpack_public_path__ + "static/media/marketingIcon.49b05b4c0777681d90de0f1ac1da2053.svg";
export { ForwardRef as ReactComponent };